import { useEffect, useState } from 'react'

import { debounce } from '@/utils/func'
import { canUseWindow } from '@/utils/browser'

function useWindowWidth(delay = 1000) {
  const [width, setWidth] = useState(canUseWindow ? window.innerWidth : 0)

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    const debouncedHandleResize = debounce(handleResize, delay)

    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [delay])

  return width
}

export default useWindowWidth
